document.addEventListener("DOMContentLoaded", () => {

  const cards = document.querySelectorAll(".shop-category__card");

  cards.forEach(card => {

    card.addEventListener("mouseenter", () => {
      card.style.transition = "all .35s ease";
    });

    card.addEventListener("mousemove", (e) => {

      const rect = card.getBoundingClientRect();

      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;

      card.style.background =
        `radial-gradient(circle at ${x}px ${y}px,
        rgba(255,107,53,.08),
        #ffffff 70%)`;

    });

    card.addEventListener("mouseleave", () => {

      card.style.background = "#ffffff";

    });

    card.addEventListener("mousedown", () => {

      card.style.transform = "translateY(-4px) scale(.98)";

    });

    

    card.addEventListener("mouseup", () => {

      card.style.transform = "translateY(-8px)";

    });

  });

});
